// Hooks
import useMentions from '@/utils/hooks/mentions/useMentions';

// Components
import DatepickerAnalytics from '@/components/composite/Datepicker/DatepickerAnalytics';
import DatepickerMentions from '@/components/composite/Datepicker/DatepickerMentions';

const MentionsDatepicker = ({ periodSelected, setPeriodSelected }) => {
    const { min_date, isLoading } = useMentions();

    if (isLoading) return null;

    return (
        <DatepickerMentions
            periodSelected={periodSelected}
            setPeriodSelected={setPeriodSelected}
            oldestMentionDate={min_date}
        />
    );
};

const HeaderDatepickerAnalytics = ({ periodSelected, setPeriodSelected, type }) => {
    if (type === 'mentions') {
        return (
            <MentionsDatepicker
                periodSelected={periodSelected}
                setPeriodSelected={setPeriodSelected}
            />
        );
    }

    return (
        <DatepickerAnalytics
            periodSelected={periodSelected}
            setPeriodSelected={setPeriodSelected}
        />
    );
};

export default HeaderDatepickerAnalytics;
